import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const showSharedFolders = isFeature('show-shared-folders') || false;
